import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const initialState = {
  title: ''
};

export const useBreadcrumbStore = create(
  persist(
    (set) => ({
      ...initialState,

      setBreadcrumbTitle: (title) => set({ title }),
    }),
    {
      name: 'breadcrumb-storage',
      partialize: (state) => ({
        title: state.title
      })
    }
  )
);
